<script>
export let image
export let formats = ['webp','jpg']
export let media = null
export let height
export let width
export let fit
export let magnification = 3
export let fill = 'blur'
const fillString = fit === "fill" || fit === "fillmax" ? "&fill=" + fill : ""
const getSrcSet = (format) => {
    const magArray = new Array(Number.isInteger(magnification) ? magnification : parseInt(magnification))
    for (let i = 0; i < magArray.length; i++) {
        let mag = i + 1
        magArray[i] = image + "?fit=" + fit + fillString + "&w="  + width * mag + "&h=" + height * mag + "&fm=" + format + " " + mag + "x"
    }
    return magArray.join(", ")
}
</script>

{#each formats as format}
    <source {media} srcset={getSrcSet(format)}  type="image/{format === "jpg" ? "jpeg" : format}">
{/each}